module.exports = __webpack_public_path__ + "files/c4e2d59141b297a7d2f34080b7a5f91e.png";